module.exports = __webpack_public_path__ + "img/Flip Card 4.289d429e.svg";